<template>
  <growth-contact-button
    v-track="'blog_post_resource_clicked'"
    v-bind="bind"
    :confirmation-toast="false"
    :loading="status === 'pending'"
    origin="blog"
    origin_page_action="download_resource_cta"
    :origin_page_id="post.id"
    :redirect="redirect"
    skip-form-if-known-user
    @skipped="onSkippedContactForm()"
  >
    {{ label }}
  </growth-contact-button>
</template>

<script lang="ts" setup>
import type { ButtonProps } from "@pollen/ui-library";

import type { BlogPostPage, BlogPostResourcePage } from "~~/model/blog.model";

const properties = defineProps<
  ButtonProps & {
    post: BlogPostPage;
    resource: Omit<BlogPostResourcePage, "file">;
  }
>();

const bind = computed(() => {
  return {
    block: properties.block,
    size: properties.size,
    variant: properties.variant,
    color: properties.color,
  };
});

const route = useRoute();
const redirect = computed(
  () =>
    properties.resource.url ||
    `${route.path}?view_resource=${properties.resource.id}`,
);

const { view, status } = useBlogPostResourceViewer({
  postId: properties.post.id,
  resourceId: properties.resource.id,
});

const label = "Découvrir";

function onSkippedContactForm() {
  if (properties.resource.url) {
    return window.open(properties.resource.url);
  }

  return view();
}
</script>
